export default "__VITE_ASSET__4ea68872__"